export type CorrelationErrorCode =
  | 'timeout'
  | 'connection_lost'
  | 'server_error'
  | 'mismatch';

export class CorrelationError extends Error {
  constructor(
    public readonly code: CorrelationErrorCode,
    public readonly serverCode?: string,
    message?: string,
  ) {
    super(message ?? `correlation error: ${code}${serverCode ? ` (${serverCode})` : ''}`);
    this.name = 'CorrelationError';
  }
}
